import { ADD_WORKERS_WHITH_AMMOUNT } from "../../../../enums/Request/request.types";

export const addWorkersToAmmountAction = (data) => {
    return {
        type: ADD_WORKERS_WHITH_AMMOUNT,
        payload: data,
    };
};
